/**
 * This file is used for adding a mentorpick course
 * in CP Tracker.
 */
import { TextField } from '@mui/material';
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Service from '../../Service/http';
import { toast } from "react-toastify";

function AddCourse({ setLoading, fetchCoursesData }) {
    const [courseId, setCourseId] = useState('');
    
    const service = new Service();
    
    async function handleAddCourse() {
        setLoading(true);
        try {
            let response = await service.post('api/course', { courseId: courseId });
            fetchCoursesData();
            toast.success(response.message);
        }
        catch(error) {
            toast.error(error.message);
        }
        setLoading(false);
    }

    return (
        <div className='card' style={{ height: '500px', width: '900px'}}>
            <h3 className='text-center card-title text-primary' style={{ margin: "3%" , marginBottom : "6%" }}>ADD NEW COURSE</h3>
            <div>
                <div className='container card-body' style={{display: 'flex', justifyContent: 'center' }}>
                    <TextField label="Course Id" style={{width: '400px'}} value={courseId} onChange={(e) => setCourseId(e.target.value)}/>
                </div>
                <div className="text-center">
                    <Button
                        onClick={handleAddCourse}
                        variant="contained"
                        style={{ width: "100%", maxWidth: "200px", margin: "20px auto", marginTop: "50px" }}
                        endIcon={<AddCircleOutlineIcon style={{ height: "20px" }} />}
                    >
                        Add Course
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AddCourse;